/**
 * Created by eliasmj on 05/11/2014.
 */
angular.module('qkr').directive('outletBox', (appConfig) => ({
       restrict: 'EA',
       scope: true,
       template: require('../../directives/outlet/outlet_box.html'),
       link(scope, element, attrs) {

       }
   }));



// WEBPACK FOOTER //
// ./src/directives/outlet/outlet_box.js